import { Route } from '@angular/router';
import { UrlSegment } from '@app/shared/types/enums/url-segment.enum';
import { ReportsComponent } from './reports.component';
import { WorkTimeReportComponent } from './work-time-report/work-time-report';

export const reportsRoutes: Route[] = [
  {
    path: '',
    component: ReportsComponent,
    children: [
      {
        path: '',
        redirectTo: UrlSegment.WORK_TIME,
        pathMatch: 'full'
      },
      {
        path: UrlSegment.WORK_TIME,
        component: WorkTimeReportComponent
      }
    ]
  }
];
